<template>
    <v-container class="ma-0 pa-0" fluid>
        <v-row class="ma-0 mb-1 pa-0 text-center">
            <v-spacer/>
            <h1>출하검사 부적합품률 목표 대비 실적</h1>
            <v-spacer/>
        </v-row>
        <v-row class="ma-0 pa-0">
            <canvas width="1560" height="150"
                    id="graph0"
                    class="canvas"/>
        </v-row>
        <v-row class="ma-0 pa-0" no-gutters>
            <template v-for="(item, i) in gridTitle">
                <v-col :key="i"
                       v-if="i===0"
                       cols="1"
                >
                    <v-card
                            class="pa-0 ma-0 text-center"
                            outlined
                            tile
                            height="45">
                        {{gridTitle[i]}}
                    </v-card>
                </v-col>
                <v-col :key="i"
                       v-if="i!==0"
                >
                    <v-card
                            class="pa-0 ma-0 text-center"
                            outlined
                            tile
                            height="45">
                        {{gridTitle[i]}}
                    </v-card>
                </v-col>
            </template>
        </v-row>
        <v-row class="ma-0 pa-0" no-gutters>
            <template v-for="(item, i) in gridData0">
                <v-col :key="i"
                       v-if="i===0"
                       cols="1"
                >
                    <v-card
                            class="pa-0 ma-0 text-center"
                            outlined
                            tile
                            height="25">
                        {{gridData0[i]}}
                    </v-card>
                </v-col>
                <v-col :key="i"
                       v-if="i!==0"
                >
                    <v-card
                            class="pa-0 ma-0 text-center"
                            outlined
                            tile
                            height="25">
                        {{gridData0[i]}}
                    </v-card>
                </v-col>
            </template>
        </v-row>
        <v-row class="ma-0 pa-0" no-gutters>
            <template v-for="(item, i) in gridData1">
                <v-col :key="i"
                       v-if="i===0"
                       cols="1"
                >
                    <v-card
                            class="pa-0 ma-0 text-center"
                            outlined
                            tile
                            height="25">
                        {{gridData1[i]}}
                    </v-card>
                </v-col>
                <v-col :key="i"
                       v-if="i!==0"
                >
                    <v-card
                            class="pa-0 ma-0 text-center"
                            outlined
                            tile
                            height="25">
                        {{gridData1[i]}}
                    </v-card>
                </v-col>
            </template>
        </v-row>
        <v-row class="ma-0 pa-0" no-gutters>
            <template v-for="(item, i) in gridData2">
                <v-col :key="i"
                       v-if="i===0"
                       cols="1"
                >
                    <v-card
                            class="pa-0 ma-0 text-center"
                            outlined
                            tile
                            height="25">
                        {{gridData2[i]}}
                    </v-card>
                </v-col>
                <v-col :key="i"
                       v-if="i!==0"
                >
                    <v-card
                            class="pa-0 ma-0 text-center"
                            outlined
                            tile
                            height="25">
                        {{gridData2[i]}}
                    </v-card>
                </v-col>
            </template>
        </v-row>
        <v-row class="ma-0 pa-0" no-gutters>
            <template v-for="(item, i) in gridData3">
                <v-col :key="i"
                       v-if="i===0"
                       cols="1"
                >
                    <v-card
                            class="pa-0 ma-0 text-center"
                            outlined
                            tile
                            height="25">
                        {{gridData3[i]}}
                    </v-card>
                </v-col>
                <v-col :key="i"
                       v-if="i!==0"
                >
                    <v-card
                            class="pa-0 ma-0 text-center"
                            outlined
                            tile
                            height="25">
                        {{gridData3[i]}}
                    </v-card>
                </v-col>
            </template>
        </v-row>
        <v-row class="ma-0 pa-0" no-gutters>
            <template v-for="(item, i) in gridData4">
                <v-col :key="i"
                       v-if="i===0"
                       cols="1"
                >
                    <v-card
                            class="pa-0 ma-0 text-center"
                            outlined
                            tile
                            height="25">
                        {{gridData4[i]}}
                    </v-card>
                </v-col>
                <v-col :key="i"
                       v-if="i!==0"
                >
                    <v-card
                            class="pa-0 ma-0 text-center"
                            outlined
                            tile
                            height="25">
                        {{gridData4[i]}}
                    </v-card>
                </v-col>
            </template>
        </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'GraphDataOG0',
  props: {
    update: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    gridTitle: [],
    gridData0: [],
    gridData1: [],
    gridData2: [],
    gridData3: [],
    gridData4: [],
    graphWidth: 1560,
    graphHeight: 150,
    MarginLeft: 60,
    MarginRight: 10,
    MarginTop: 10,
    MarginBottom: 18,
    ctx: null,
    max: 0
  }),
  methods: {
    getTitle () {
      this.gridTitle = []
      this.gridTitle.push('출하검사부적합품률(월단위)')
      let year = new Date().getFullYear()
      this.gridTitle.push((year - 2).toString() + '년')
      this.gridTitle.push((year - 1).toString() + '년')
      this.gridTitle.push(year.toString() + '년')
      for (let i = 1; i <= 12; i++) {
        this.gridTitle.push(i.toString() + '월')
      }
    },
    getData0 () {
      // 목표
      this.gridData0 = []
      this.gridData0.push('목표(ppm)')
      this.$axios.get('/api/monthlytargetvalues/' + this.code + '/' + this.category, this.$Common.headerApiRequest())
        .then((res) => {
          console.log('succeeded get monthlytargetvalues -> ' + res)
          let yearSum0 = 0
          let yearCount0 = 0
          let yearSum1 = 0
          let yearCount1 = 0
          let yearSum2 = 0
          let yearCount2 = 0
          let monthSum = []
          for (let i = 0; i < 12; i++) {
            monthSum.push(0)
          }
          let year = new Date().getFullYear()
          if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].year.toString() === (year - 2).toString()) {
                yearSum0 += this.$Common.getNumber(res.data[i].value)
                yearCount0++
              }
              if (res.data[i].year.toString() === (year - 1).toString()) {
                yearSum1 += this.$Common.getNumber(res.data[i].value)
                yearCount1++
              }
              if (res.data[i].year.toString() === year.toString()) {
                yearSum2 += this.$Common.getNumber(res.data[i].value)
                yearCount2++
                for (let j = 0; j < 12; j++) {
                  if (res.data[i].month.toString() === (j + 1).toString()) {
                    monthSum[j] += this.$Common.getNumber(res.data[i].value)
                  }
                }
              }
            }
          }
          let avr = 0
          if (yearSum0 > 0 && yearCount0 > 0) {
            avr = yearSum0 / yearCount0
          }
          this.gridData0.push(avr.toString())
          avr = 0
          if (yearSum1 > 0 && yearCount1 > 0) {
            avr = yearSum1 / yearCount1
          }
          this.gridData0.push(avr.toString())
          avr = 0
          if (yearSum2 > 0 && yearCount2 > 0) {
            avr = yearSum2 / yearCount2
          }
          this.gridData0.push(avr.toString())
          for (let i = 0; i < 12; i++) {
            this.gridData0.push(monthSum[i])
          }
          this.getData2()
        })
        .catch((e) => {
          console.log('failed get monthlytargetvalues -> ' + JSON.stringify(e.response.data))
        })
    },
    getData1 () {
      this.gridData1 = []
      this.gridData1.push('실적(ppm)')

      for (let i = 0; i < 15; i++) {
        let value = 0
        if (this.gridData2[i + 1] > 0 && this.gridData3[i + 1] > 0) {
          value = parseFloat(this.gridData2[i + 1]) / parseFloat(this.gridData3[i + 1]) * 1000000
        }
        this.gridData1.push(value.toFixed(1))
      }
      this.getData4()
    },
    getData2 () {
      this.gridData2 = []
      this.gridData2.push('부적합건수')
      this.$axios.get('/api/outgoinginspections/' + this.code, this.$Common.headerApiRequest())
        .then((res) => {
          console.log('succeeded get outgoinginspections -> ' + res)
          let yearSum0 = 0
          let yearSum1 = 0
          let yearSum2 = 0
          let monthSum = []
          for (let i = 0; i < 12; i++) {
            monthSum.push(0)
          }
          let year = new Date().getFullYear()
          if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              let yearData = res.data[i].inspectionDate.substr(0, 4)
              let monthData = parseInt(res.data[i].inspectionDate.substr(5, 2))
              if (yearData === (year - 2).toString()) {
                yearSum0 += this.$Common.getNumber(res.data[i].defectedNumber)
              }
              if (yearData === (year - 1).toString()) {
                yearSum1 += this.$Common.getNumber(res.data[i].defectedNumber)
              }
              if (yearData === year.toString()) {
                yearSum2 += this.$Common.getNumber(res.data[i].defectedNumber)
                for (let j = 0; j < 12; j++) {
                  if (monthData === j + 1) {
                    monthSum[j] += this.$Common.getNumber(res.data[i].defectedNumber)
                  }
                }
              }
            }
            this.gridData2.push((yearSum0).toFixed(1))
            this.gridData2.push((yearSum1).toFixed(1))
            this.gridData2.push((yearSum2).toFixed(1))
            for (let i = 0; i < 12; i++) {
              this.gridData2.push(monthSum[i])
            }
          }
          this.getData3()
        })
        .catch((e) => {
          console.log('failed get outgoinginspections -> ' + JSON.stringify(e.response.data))
        })
    },
    getData3 () {
      this.gridData3 = []
      this.gridData3.push('부적합검사건수')
      this.$axios.get('/api/outgoinginspections/' + this.code, this.$Common.headerApiRequest())
        .then((res) => {
          console.log('succeeded get outgoinginspections -> ' + res)
          let yearSum0 = 0
          let yearSum1 = 0
          let yearSum2 = 0
          let monthSum = []
          for (let i = 0; i < 12; i++) {
            monthSum.push(0)
          }
          let year = new Date().getFullYear()
          if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              let yearData = res.data[i].inspectionDate.substr(0, 4)
              let monthData = parseInt(res.data[i].inspectionDate.substr(5, 2))
              if (yearData === (year - 2).toString()) {
                yearSum0 += this.$Common.getNumber(res.data[i].sampleNumber)
              }
              if (yearData === (year - 1).toString()) {
                yearSum1 += this.$Common.getNumber(res.data[i].sampleNumber)
              }
              if (yearData === year.toString()) {
                yearSum2 += this.$Common.getNumber(res.data[i].sampleNumber)
                for (let j = 0; j < 12; j++) {
                  if (monthData === j + 1) {
                    monthSum[j] += this.$Common.getNumber(res.data[i].sampleNumber)
                  }
                }
              }
            }
            this.gridData3.push((yearSum0).toFixed(1))
            this.gridData3.push((yearSum1).toFixed(1))
            this.gridData3.push((yearSum2).toFixed(1))
            for (let i = 0; i < 12; i++) {
              this.gridData3.push(monthSum[i])
            }
          }
          this.getData1()
        })
        .catch((e) => {
          console.log('failed get outgoinginspections -> ' + JSON.stringify(e.response.data))
        })
    },
    getData4 () {
      this.gridData4 = []
      this.gridData4.push('달성률')
      for (let i = 0; i < 15; i++) {
        let value = 0
        if (this.gridData0[i + 1] > 0 && this.gridData1[i + 1] > 0) {
          value = parseFloat(this.gridData1[i + 1]) / parseFloat(this.gridData0[i + 1]) * 100
        }
        this.gridData4.push(value.toFixed(1) + '%')
      }
      this.draw()
    },
    draw () {
      // 기본 정보 생성.
      this.makeBaseInfo()

      // 배경 클리어.
      this.drawClear()

      // 그래프 라인 그리기.
      this.drawGraphLine()

      // 막대 그리기.
      this.drawDataBar()

      // 목표 그리기.
      this.drawDataLine()
    },
    makeBaseInfo () {
      this.max = 0
      for (let i = 1; i < this.gridData0.length; i++) {
        if (this.max < parseInt(this.gridData0[i])) {
          this.max = parseInt(this.gridData0[i])
        }
        if (this.max < parseInt(this.gridData1[i])) {
          this.max = parseInt(this.gridData1[i])
        }
      }
    },
    drawClear () {
      // 배경색 처리
      this.ctx.fillStyle = 'white'
      this.ctx.lineWidth = 1
      this.ctx.beginPath()
      this.ctx.fillRect(0, 0, this.graphWidth, this.graphHeight)
      this.ctx.fill()
    },
    drawGraphLine () {
      // 하단 라인
      this.ctx.setLineDash([])
      this.ctx.lineWidth = 1
      this.ctx.strokeStyle = 'black'
      this.ctx.beginPath()
      this.ctx.moveTo(this.MarginLeft, this.graphHeight - this.MarginBottom)
      this.ctx.lineTo(this.graphWidth - this.MarginRight, this.graphHeight - this.MarginBottom)
      this.ctx.stroke()
      // 좌측 라인
      this.ctx.beginPath()
      this.ctx.moveTo(this.MarginLeft, this.MarginTop)
      this.ctx.lineTo(this.MarginLeft, this.graphHeight - this.MarginBottom)

      // 좌측 정보 0
      this.ctx.stroke()
      this.ctx.strokeStyle = 'black'
      this.ctx.fillStyle = 'black'
      this.ctx.font = '12px 맑은고딕'
      this.ctx.textBaseline = 'middle'
      this.ctx.textAlign = 'right'
      this.ctx.fillText('0', this.MarginLeft - 5, this.graphHeight - this.MarginBottom)

      // 좌측 정보 Max
      this.ctx.fillText(this.max.toFixed(0), this.MarginLeft - 5, this.MarginTop)

      // 하단 정보.
      this.ctx.textAlign = 'center'
      this.ctx.textBaseline = 'top'
      let distance = (this.graphWidth - this.MarginLeft - this.MarginRight) / (this.gridTitle.length - 1)
      for (let i = 1; i < this.gridTitle.length; i++) {
        this.ctx.fillText(this.gridTitle[i], this.MarginLeft + (distance * i) - (distance / 2), this.graphHeight - this.MarginBottom + 3)
      }
    },
    drawDataLine () {
      this.ctx.fillStyle = 'rgb(125, 167, 217)'
      this.ctx.strokeStyle = 'rgb(0, 0, 0)'
      this.ctx.setLineDash([])
      this.ctx.lineWidth = 2
      this.ctx.beginPath()

      let distance = (this.graphWidth - this.MarginLeft - this.MarginRight) / (this.gridData0.length - 1)
      let first = false
      for (let i = 1; i < this.gridData0.length; i++) {
        let value = parseFloat(this.gridData0[i])
        let y = this.getY(value)
        if (!first) {
          this.ctx.moveTo(this.MarginLeft + (distance * i) - (distance / 2), y)
          first = true
        } else {
          this.ctx.lineTo(this.MarginLeft + (distance * i) - (distance / 2), y)
        }
      }
      this.ctx.stroke()
    },
    drawDataBar () {
      this.ctx.fillStyle = 'rgb(125, 167, 217)'
      this.ctx.strokeStyle = 'rgb(0, 0, 0)'
      this.ctx.setLineDash([])
      this.ctx.lineWidth = 1
      this.ctx.beginPath()
      let distance = (this.graphWidth - this.MarginLeft - this.MarginRight) / (this.gridData1.length - 1)
      for (let i = 1; i < this.gridData1.length; i++) {
        let value = parseFloat(this.gridData1[i])
        if (value > 0) {
          let y = this.getY(value)
          let height = this.graphHeight - this.MarginBottom - y
          this.ctx.fillRect(this.MarginLeft + (distance * i) - (distance / 2) - 20,
            y,
            40,
            height
          )
        }
      }
      this.ctx.fill()
    },
    getY (value) {
      let height = this.graphHeight - this.MarginTop - this.MarginBottom
      let fY = this.graphHeight - this.MarginBottom
      fY -= value / this.max * height
      return fY
    }
  },
  mounted () {
    document.getElementById('graph0').height = this.graphHeight
    document.getElementById('graph0').width = this.graphWidth
    this.ctx = document.getElementById('graph0').getContext('2d')
    // this.ctx = this.$el.getContext('2d')
  },
  created () {
    this.getTitle()
    this.getData0()
  },
  watch: {
    update () {
      this.getTitle()
      this.getData0()
    }
  }

}
</script>

<style scoped>
    .canvas {
        border: 1px solid #000;
    }
</style>
